module.exports = __webpack_public_path__ + "img/img-zhilian-s6-tuya.4df27107.jpg";